import {
  getTcpRoles,
  getTCPRolesWithRootStations,
  getUserLoginFromParent,
  getUserNameFromParent,
} from "../handler/ParentDataHandler";
import { AMAZON_SUFFIX, TIMEOUT_STRING } from "../util/Constants";

export async function getEmployeeTCPRoles() {
  let response = await getTcpRoles();
  let roles = [];
  try {
    if (response != null && response.roles != null) {
      // As the backend API is not returning a usal JSON string due to certain restriction, JSON.parse method won't parse the response properly
      // e.g. sample response.roles: "[AmazonFacility::Feature Management Console Editor, Admin, AmazonFacility::Warehouse Manager]"
      // Therefore, to get a list of roles, we have to manually remove double quotes and square bracktes and then split the string by ","
      roles = response.roles.replace(/["[\]']+/g, "").split(",");
      roles.forEach((element, index) => {
        // Remove leading and trailing white spaces for each role
        roles[index] = roles[index].trim();
      });
    }
  } catch (e) {
    console.error(e);
  }
  return roles;
}

export async function getEmployeeTCPRolesWithRootStations() {
  let response = await getTCPRolesWithRootStations();
  let parsedResponse = {};
  try {
    if (response && response.rolesWithRootStations) {
      parsedResponse = JSON.parse(response.rolesWithRootStations);
    }
  } catch (e) {
    console.error(e);
  }
  return parsedResponse;
}

export async function getUserLogin() {
  let userLogin = "user";
  try {
    userLogin = await getTcpEmployee();
    if (userLogin && userLogin.endsWith(AMAZON_SUFFIX)) {
      userLogin = userLogin.replace(AMAZON_SUFFIX, "");
    }
  } catch (e) {
    console.error(e);
  }
  return userLogin;
}

export async function getUserName() {
  let userName = await getTcpEmployee();
  if (!userName.endsWith(AMAZON_SUFFIX)) {
    userName += AMAZON_SUFFIX;
  }
  return userName;
}

export async function getTcpEmployee() {
  let response = await getUserLoginFromParent();
  if (response === TIMEOUT_STRING) {
    response = await getUserNameFromParent();
  }
  if (response.name === undefined) {
    return "";
  }
  return JSON.parse(response.name);
}



// WEBPACK FOOTER //
// ./src/components/resources/EmployeeResource.js